/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentRequest } from './AppointmentRequest';
import {
    AppointmentRequestFromJSON,
    AppointmentRequestFromJSONTyped,
    AppointmentRequestToJSON,
    AppointmentRequestToJSONTyped,
} from './AppointmentRequest';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface BulkAppointmentBookingRequest
 */
export interface BulkAppointmentBookingRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof BulkAppointmentBookingRequest
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Array<AppointmentRequest>}
     * @memberof BulkAppointmentBookingRequest
     */
    appointments: Array<AppointmentRequest>;
}

/**
 * Check if a given object implements the BulkAppointmentBookingRequest interface.
 */
export function instanceOfBulkAppointmentBookingRequest(value: object): value is BulkAppointmentBookingRequest {
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('appointments' in value) || value['appointments'] === undefined) return false;
    return true;
}

export function BulkAppointmentBookingRequestFromJSON(json: any): BulkAppointmentBookingRequest {
    return BulkAppointmentBookingRequestFromJSONTyped(json, false);
}

export function BulkAppointmentBookingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkAppointmentBookingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'appointments': ((json['appointments'] as Array<any>).map(AppointmentRequestFromJSON)),
    };
}

export function BulkAppointmentBookingRequestToJSON(json: any): BulkAppointmentBookingRequest {
    return BulkAppointmentBookingRequestToJSONTyped(json, false);
}

export function BulkAppointmentBookingRequestToJSONTyped(value?: BulkAppointmentBookingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'appointments': ((value['appointments'] as Array<any>).map(AppointmentRequestToJSON)),
    };
}

